module.exports = __webpack_public_path__ + "static/media/ipk2022_Branding.005.e62f0a2b.jpeg";